<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title title-next-select">
            <md-icon>search</md-icon>회장단 선택 :
          </h4>
          <div class="title-select">
            <select v-model="presidencyObj" name="presidencyObj" @change="changePresidencyCd">
              <option v-for="item in presidencyCdList" :key="item.code" :label="item.codeNm" v-bind:value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>회장</th>
              <td>
                <input type="text" v-model="presidencyData.chairmanNm" maxlength="20"/>
              </td>
              <th>임기</th>
              <td>
                <input type="text" v-model="presidencyData.term" maxlength="30"/>
              </td>
              <th>수석부회장</th>
              <td>
                <input type="text" v-model="presidencyData.headVicePrcy" maxlength="30"/>
              </td>
              <th>감사</th>
              <td>
                <input type="text" v-model="presidencyData.auditor" maxlength="30"/>
              </td>
            </tr>
            <tr>
              <th>부회장</th>
              <td>
                <input type="text" v-model="presidencyData.vicePrcy" maxlength="30"/>
              </td>
              <th>사무총장</th>
              <td>
                <input type="text" v-model="presidencyData.secGeneral" maxlength="30"/>
              </td>
              <th>회비납부액 </th>
              <td>
                <input type="text" v-model="presidencyData.feeAmt" maxlength="30"/>
              </td>
              <th>납부인원</th>
              <td>
                <input type="text" v-model="presidencyData.feeCnt" maxlength="30"/>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="savePresidency" :disabled="!presidencyObj.code">
            <md-icon>check</md-icon>저 장
          </md-button>
          <md-button class="md-default md-sm" @click="deletePresidency" :disabled="!presidencyObj.code">
            <md-icon>clear</md-icon>삭 제
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
    <!-- 회장단 상세 -->
    <div class="md-layout">
      <!-- 일괄 처리영역 -->
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>장학금 일괄등록
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">엑셀 업로드</h5>
              <div class="inline-flex mb10">
                <input type="file" class="hidden-input-file" id="scholarFileInput" accept=".xlsx">
                <input type="text" v-model="scholarExcelFileName" disabled>
                <button @click="onClickSearchExcel(1)">
                  <md-icon>search</md-icon>엑셀 파일 찾기
                </button>
              </div>
              <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile(1)" :disabled="!scholarExcelFile">
                <md-icon>publish</md-icon>엑셀 업로드
              </md-button>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>위원 일괄등록
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">엑셀 업로드</h5>
              <div class="inline-flex mb10">
                <input type="file" class="hidden-input-file" id="executiveFileInput" accept=".xlsx">
                <input type="text" v-model="executiveExcelFileName" disabled>
                <button @click="onClickSearchExcel(2)">
                  <md-icon>search</md-icon>엑셀 파일 찾기
                </button>
              </div>
              <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile(2)" :disabled="!executiveExcelFile">
                <md-icon>publish</md-icon>엑셀 업로드
              </md-button>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <!-- 그리드 영역 -->
      <div class="md-layout-item md-size-80 no-padding" v-show="presidencyObj.code">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>history</md-icon>
              {{presidencyObj.codeNm}}
            </h4>
          </md-card-header>
          <div class="md-group tab-area">
            <md-button class="md-default" @click="onClickTab(1)">부회장</md-button>
            <md-button class="md-default" @click="onClickTab(2)">감사</md-button>
            <md-button class="md-default" @click="onClickTab(3)">상훈위원</md-button>
            <md-button class="md-default" @click="onClickTab(4)">장학위원</md-button>
            <md-button class="md-default" @click="onClickTab(5)">편집위원</md-button>
            <md-button class="md-default" @click="onClickTab(100)">장학금</md-button>
          </div>

          <div class="simple-tab-group">
            <!-- 1~번 탭 -->
            <presidency-brd-list-comp :show-tab-number.sync="showTabNumber" ref="presidencyBrdList">
              <div slot="bottomRightArea">
                <md-card-actions md-alignment="right">
                  <div>
                    <md-button class="md-default md-sm" @click="deleteExecutive">
                      <md-icon>clear</md-icon>삭 제
                    </md-button>
                    <md-button class="md-success md-sm" @click="downloadExcel1(showTabNumber)" v-exel-btn="[5,3]">
                      <md-icon>get_app</md-icon>Excel 다운로드
                    </md-button>
                  </div>
                </md-card-actions>
              </div>
            </presidency-brd-list-comp>

            <!-- 장학금 탭 -->
            <presidency-scha-list-comp :show-tab-number.sync="showTabNumber" ref="presidencySchaList">
              <div slot="bottomRightArea">
                <md-card-actions md-alignment="right">
                  <div>
                    <md-button class="md-default md-sm" @click="deleteScholar">
                      <md-icon>clear</md-icon>삭 제
                    </md-button>
                    <md-button class="md-success md-sm" @click="downloadExcel2" v-exel-btn="[5,3]">
                      <md-icon>get_app</md-icon>Excel 다운로드
                    </md-button>
                  </div>
                </md-card-actions>
              </div>
            </presidency-scha-list-comp>
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import parser from "@/kuaa/kuaa-parser";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";

import Swal from "sweetalert2";
import moment from "moment";


import presidencyBrdListComp from "@/pages/Scholarship/Components/presidencyBrdListComp"
import presidencySchaListComp from "@/pages/Scholarship/Components/presidencySchaListComp"

export default {

  components: {
    presidencyBrdListComp,
    presidencySchaListComp
  },

  created() {
    this.getPresidencyCDList();
  },

  computed: {
  },

  watch : {
  },

  data(){
    return {
      formatter,
      showTabNumber : 1,

      // 장학금 일괄 처리
      scholarExcelFile : null,
      scholarExcelFileName : '',

      // 위원 일괄 처리
      executiveExcelFile : null,
      executiveExcelFileName : '',

      presidencyCdList : [],
      presidencyObj : {
        'code' : null,
        'codeNm' : null
      }, // 회장단 선택
      presidencyData : {
        "presidencyCd" : null,
        "chairmanNm" : "",
        "term" : "",
        "headVicePrcy" : "",
        "auditor" : "",
        "secGeneral" : "",
        "feeAmt" : "",
        "feeCnt" : ""
      }
    };
  },

  methods: {
    clearPresidencyObj(){
      this.presidencyObj = {
        'code' : null,
        'codeNm' : null
      };
      this.clearPresidencyData();
    },
    clearPresidencyData () {
      this.presidencyData =  {
        "presidencyCd" : this.presidencyObj.code,
        "chairmanNm" : "",
        "term" : "",
        "headVicePrcy" : "",
        "auditor" : "",
        "secGeneral" : "",
        "feeAmt" : "",
        "feeCnt" : "",
      };
    },
    getPresidencyCDList (){
      kuaaFnc.fncPresidencyCodes(null,res => {
        this.presidencyCdList = res.data.data.contents;
      });
    },

    changePresidencyCd(){
      let params = {presidencyCd : this.presidencyObj.code};
      let modalOptions = kuaaFnc.getSwalModaloptions();
      kuaaApi.sendServer(
        URL_CONST.GET_PRESIDENCY_INFO_LIST,
        params,
        "post",
        response => {
          if (response.data.result){
            if(response.data.data.contents.length){
              this.presidencyData = response.data.data.contents[0];
            }else{
              this.clearPresidencyData();
            }
            this.onClickTab(1);
          } else {
            modalOptions.html = `조회 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
    },

    savePresidency(){
      let modalOptions = kuaaFnc.getSwalModaloptions();
      kuaaApi.sendServer(
        URL_CONST.SAVE_PRESIDENCY_INFO,
        this.presidencyData,
        "post",
        response => {
          if (response.data.success){
            modalOptions.html = `저장 되었습니다.`;
            Swal.fire(modalOptions);
          } else {
            modalOptions.html = `저장 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
    },

    deletePresidency(){
      let params = {"presidencyCd" : this.presidencyObj.code}

      let modalOptions = kuaaFnc.getSwalModaloptions();
      kuaaApi.sendServer(
        URL_CONST.DELETE_PRESIDENCY_INFO,
        params,
        "post",
        response => {
          if (response.data.success){
            this.clearPresidencyObj();
            modalOptions.html = `삭제 되었습니다.`;
            Swal.fire(modalOptions);
          } else {
            modalOptions.html = `삭제 실패 하였습니다.`;
            Swal.fire(modalOptions);
          }
        }
      );
    },
    onClickTab(num){
      this.showTabNumber = num;
      if(num==100){
        this.$refs.presidencySchaList.sendQuery(this.presidencyObj.code);
      }else{
        this.$refs.presidencyBrdList.sendQuery(this.presidencyObj.code, num);
      }
    },
    deleteExecutive (){
      let row = this.$refs.presidencyBrdList.getCheckedRows();
      if(!row.length){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'교우를 선택해 주세요'}));
        return;
      }
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "위원을 삭제 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {

        let params = [];
        row.forEach((obj)=>{
          params.push({
            'presidencyCd' : this.presidencyData.presidencyCd,
            'seqNo' : obj.seqNo,
            'memberNo' : obj.memberNo,
          })
        });

        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.DELETE_PRESIDENCY_BRD,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                if(this.presidencyObj.code){
                  this.changePresidencyCd();
                }
              } else {
                modalOptions.html = `삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });

    },

    downloadExcel1(num){
      this.query = {
        "perPage":"20",
        "presidencyCd": this.presidencyObj.code,
        "page":"1",
        "fileName" : '역대회장단관리',
        "presiLevelCd" : '0' + num
      }
      kuaaApi.requestFileDownload(
          URL_CONST.PRESIDENCY_BRD_EXCEL_DOWNLOAD,
          this.query,
          '역대회장단관리.xlsx'
      );
    },

    downloadExcel2(){
      this.query = {
        "perPage":"20",
        "presidencyCd":this.presidencyObj.code,
        "fileName" : '역대회장단관리',
        "page":"1"
      }
      kuaaApi.requestFileDownload(
          URL_CONST.PRESIDENCY_SCHA_EXCEL_DOWNLOAD,
          this.query,
          '역대회장단관리.xlsx'
      );
    },

    deleteScholar (){
      let row = this.$refs.presidencySchaList.getCheckedRows();
      if(!row.length){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:'항목을 선택해 주세요'}));
        return;
      }
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "항목을 삭제 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {

        let params = [];
        row.forEach((obj)=>{
          params.push({
            'presidencyCd' : obj.presidencyCd,
            'seqNo' : obj.seqNo,
          })
        });

        if (result.value) {
          modalOptions = kuaaFnc.getSwalModaloptions();
          kuaaApi.sendServer(
            URL_CONST.DELETE_PRESIDENCY_SCHA,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `삭제 되었습니다.`;
                Swal.fire(modalOptions);
                if(this.presidencyObj.code){
                  this.changePresidencyCd();
                }
              } else {
                modalOptions.html = `삭제 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });

    },
    onClickSearchExcel(type){
      let input = type == 1 ? document.getElementById("scholarFileInput") : document.getElementById("executiveFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        if(type == 1){
          this.scholarExcelFileName = file.name;
          this.scholarExcelFile = file;
        }else{
          this.executiveExcelFileName = file.name;
          this.executiveExcelFile = file;
        }
      };
      input.click();
    },
    uploadExcelFile(type) {
      if(type==1){
        this.uploadExcelScholar();
      }else{
        this.uploadExcelExecutive();
      }
    },
    uploadExcelExecutive(){
      parser.parseXlsScholarshipExecutiveBundleData(this.executiveExcelFile, (res)=>{
        let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
          html: "위원 일괄등록 하시겠습니까?",
        });

        Swal.fire(modalOptions).then(result => {
          if (result.value) {
            modalOptions = kuaaFnc.getSwalModaloptions();
            kuaaApi.sendServer(
              URL_CONST.SAVE_PRESIDENCY_BRD,
              res,
              "post",
              response => {
                if (response.data.success){
                  modalOptions.html = `추가 되었습니다.`;
                  Swal.fire(modalOptions);
                  if(this.presidencyObj.code){
                    this.changePresidencyCd();
                    this.executiveExcelFileName = '';
                    this.executiveExcelFile = null;
                  }
                } else {
                  modalOptions.html = `추가 실패 하였습니다.`;
                  Swal.fire(modalOptions);
                }
              }
            );
          }
        });
      });
    },
    uploadExcelScholar(){
      parser.parseXlsScholarshipScholarBundleData(this.scholarExcelFile, (res)=>{
        let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
          html: "위원 일괄등록 하시겠습니까?",
        });

        Swal.fire(modalOptions).then(result => {
          if (result.value) {
            modalOptions = kuaaFnc.getSwalModaloptions();
            kuaaApi.sendServer(
              URL_CONST.SAVE_PRESIDENCY_SCHA,
              res,
              "post",
              response => {
                if (response.data.success){
                  modalOptions.html = `추가 되었습니다.`;
                  Swal.fire(modalOptions);
                  if(this.presidencyObj.code){
                    this.changePresidencyCd();
                    this.scholarExcelFileName = '';
                    this.scholarExcelFile = null;
                  }
                } else {
                  modalOptions.html = `추가 실패 하였습니다.`;
                  Swal.fire(modalOptions);
                }
              }
            );
          }
        });
      });
    }
  }
}
</script>

<style scoped>
  .title-next-select {display: inline-block; vertical-align: middle;}
  .title-select {display: inline-block; vertical-align: middle; margin-left: 10px;min-width: 300px;}
</style>